// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__6s8PJ","load1":"Spinner_load1__1Tip7"};